import { BaseWebComponentView } from '../../../../framework/BaseWebComponentView';
import { TemplateState } from '../../../../types/common/types';
import { GzButtonWebComponent } from '../../../../ui/gzButton';
import { CompanyData } from '../../../types/company-data';
import { CompanyDetailsFormWebComponent } from '../../companyDetailsForm';
import { WEB_COMPONENT_COMPANY_DETAILS_FORM } from '../../../../webcomponents.constants';
import { Subscription } from 'rxjs';
import { CompanyActionContext } from '../../types/CompanyActionContext';
import { ButtonColors } from '../../../../ui/gzButton/types';
import { GzInfoBoxWebComponent } from '../../../../ui/gzInfoBox';
import { InfoBoxSeverity } from '../../../../ui/gzInfoBox/types';
import { toggleVisibility } from '../../../../utils/htmlElement.utils';

export class CompanyDetailsTabView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;

    $readonlyNotice: GzInfoBoxWebComponent;

    $companyDetailsForm: CompanyDetailsFormWebComponent;

    $saveButton: GzButtonWebComponent;
    $cancelButton: GzButtonWebComponent;
  };

  /**
   * Data for the current company. Set from the Component
   */
  private company: CompanyData;

  private formGroupSubscription: Subscription | null = null;

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),

      $readonlyNotice: this.shadow.querySelector('#readonly-notice'),

      $companyDetailsForm: this.shadow.querySelector(WEB_COMPONENT_COMPANY_DETAILS_FORM),

      $saveButton: this.shadow.querySelector('#save-button'),
      $cancelButton: this.shadow.querySelector('#cancel-button'),
    };

    this.setLoadingState();

    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations() {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
  }

  setTranslatedStrings() {
    this.dom.$readonlyNotice.severity = InfoBoxSeverity.INFORMATIVE;
    this.dom.$readonlyNotice.innerHTML = this.commonStrings.readOnlyNotice;

    this.dom.$saveButton.innerHTML = this.commonStrings.save;
    this.dom.$cancelButton.innerHTML = this.commonStrings.cancel;
  }

  public setLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.LOADING);
  }

  public removeLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
  }

  public setCompany(company: CompanyData) {
    this.company = company;
  }

  buildSuccessView(data: { context: CompanyActionContext }) {
    this.dom.$companyDetailsForm.injectDependencies(this.dependencies);
    this.dom.$companyDetailsForm.formContext = data.context;

    this.dom.$companyDetailsForm
      .start()
      .then(() => {
        this.dom.$companyDetailsForm.setCompanyData(this.company).catch(console.error);

        this.toggleReadOnlyNoticeVisibilityForCompanyDetailsTab();

        if (this.dom.$companyDetailsForm.isReadOnly) {
          this.dom.$cancelButton.color = ButtonColors.SECONDARY;
        }

        // enable / disable "Save" button based on formGroup's validity
        this.formGroupSubscription = this.dom.$companyDetailsForm.valid$.subscribe({
          next: valid => {
            this.dom.$saveButton.disabled = !valid || this.dom.$companyDetailsForm.isReadOnly;
          },
        });

        this.removeLoadingState();
      })
      .catch(console.error);
  }

  buildErrorView(error: Error) {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);
  }

  protected onDisconnect() {
    this.formGroupSubscription?.unsubscribe();
  }

  private toggleReadOnlyNoticeVisibilityForCompanyDetailsTab() {
    if (!this.dom.$companyDetailsForm.isReadOnly) {
      return;
    }

    toggleVisibility(this.dom.$readonlyNotice, true);
  }
}
